<template>
  <v-row class="theme-form px-0">  
    <v-col
      v-for="color in colors"
      :key="color.id"
      cols="12"
      sm="4"
      md="3"
    >
      <v-menu
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
          >
            <v-text-field
              v-model="color.code"
              outlined
              readonly
              hide-details
              :label="color.name"
              dense
              class="fld"
              :color="color.code"
            >
              <template v-slot:append>
                <v-icon
                  :color="color.code"
                  class="palette"
                >
                  mdi-palette
                </v-icon>
              </template>
            </v-text-field>
          </div>
        </template>

        <v-card>
          <v-color-picker
            v-model="color.code"
            mode="hexa"
            @update:color="set()"
          />
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
const getColors = (selected = {}) => {
  const getSelected = (key, defaultVal = "#000000") =>
    selected && selected[key] ? selected[key] : defaultVal; 
  let colors = [
    // BodyBg : application background color
    { name: "Body Background", code: getSelected("bodyBg", "#0D7E83"), id: "bodyBg" },
    // PrimaryBg :  cards and menu item  background color
    {
      name: "Primary Background",
      code: getSelected("primaryBg", "#FFFFFF"),
      id: "primaryBg"
    },
    // Primary : mostly used for text colors
    { name: "Main Color", code: getSelected("color", "#2F0A4D"), id: "color" },
    { name: "Primary", code: getSelected("primary", "#4C8F80"), id: "primary" },
    
    { name: "Warning", code: getSelected("warning", "#F44336"), id: "warning" },
    { name: "Success", code: getSelected("success", "#00FF00"), id: "success" },
    { name: "Error", code: getSelected("error", "#F44336"), id: "error" },

    // FldBorder : field border color
    { name: "Field Border", code: getSelected("fldBorder", "#2F0A4D"), id: "fldBorder" },
    // FldColor : field text color
    { name: "Field Color", code: getSelected("fldColor", "#000000"), id: "fldColor" },

    { name: "Title Background", code: getSelected("titleBg", "#ECEDF4"), id: "titleBg" },
    { name: "Title Text", code: getSelected("titleText", "#000000"), id: "titleText" },
    {
      name: "Confirm Box Background",
      code: getSelected("confirmBoxBg", "#ECEDF4"),
      id: "confirmBoxBg"
    },
    {
      name: "ConfirmBox Text",
      code: getSelected("confirmBoxText", "#000000"),
      id: "confirmBoxText"
    },
    { name: "Action Button", code: getSelected("actionBtn", "#2F0A4D"), id: "actionBtn" },
    {
      name: "Action Button Text",
      code: getSelected("actionBtnText", "#FFFFFF"),
      id: "actionBtnText"
    },
    {
      name: "Primary Button",
      code: getSelected("primaryBtn", "#2F0A4D"),
      id: "primaryBtn"
    },
    {
      name: "Primary Button Text",
      code: getSelected("primaryBtnText", "#FFFFFF"),
      id: "primaryBtnText"
    },
    {
      name: "Secondary Button",
      code: getSelected("secondaryBtn", "#2F0A4D"),
      id: "secondaryBtn"
    },
    {
      name: "Secondary Button Text",
      code: getSelected("secondaryBtnText", "#FFFFFF"),
      id: "secondaryBtnText"
    },
    { name: "Info Button", code: getSelected("infoBtn", "#2F0A4D"), id: "infoBtn" },
    {
      name: "Info Button Text",
      code: getSelected("infoBtnText", "#FFFFFF"),
      id: "infoBtnText"
    },
    { name: "Accent Button", code: getSelected("accentBtn", "#2F0A4D"), id: "accentBtn" },
    {
      name: "Accent Button Text",
      code: getSelected("accentBtnText", "#FFFFFF"),
      id: "accentBtnText"
    },
    {
      name: "Header Background",
      code: getSelected("headerBg", "#ECEDF4"),
      id: "headerBg"
    },
    { name: "Header Text", code: getSelected("headerText", "#FFF"), id: "headerText" },
    {
      name: "Filter Background",
      code: getSelected("filterBg", "#0D7E83"),
      id: "filterBg"
    },
    { name: "Filter Text", code: getSelected("filterText", "#7A65E1"), id: "filterText" },
    {
      name: "Filter Selected Background",
      code: getSelected("filterSelectBg", "#2F0A4D"),
      id: "filterSelectBg"
    },
    { name: "Filter Selected Text ", code: getSelected("filterSelectText", "#FFF"), id: "filterSelectText" }
    // { name: "Separator Line", code: getSelected("separatorLine", "#808080"), id: "separatorLine" }
  ];
  return colors;
};

export default {
  name: "Theme",
  props: {
    selected: {
      type: Object,
      required: true
    },
    setDefault: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      colors: getColors(this.selected)
    };
  },
  watch:{
    selected(newVal){ 
      if(newVal){
       
        this.colors = getColors(this.selected);
        
    //   if (this.setDefault && (this.selected && !this.selected.light)) {
    //   this.set();
    // }
      }
     
    }
  },
  created(){
    // setting the default colors for theme variables
    if (this.setDefault && (this.selected && !this.selected.light)) {
      this.set();
    }
  },
  methods: {
    set() { 
      
      let theme = {};
      this.colors.forEach((color) =>  {
        theme[color.id] = color.code;
      }); 
      

      this.$emit("update:selected", theme);
    }
  }
};
</script>

<style lang="scss">
.theme-form {
  .palette {
    cursor: pointer;
  }
  .color-btn {
    border-radius: 0 4px 4px 0;
  }
}
</style>